/**
 * RFC-150: Marketed Study Modes — display rollup over the underlying DB
 * `study_modes` rows. Pages and the marketing contract test both import this
 * so the public count, labels, and DB-id mapping never drift.
 *
 * NOTE: `practice-all` is a meta-mode and intentionally NOT a marketed mode.
 * If a new id is added to `StudyMode` later, EITHER add an entry below OR
 * extend the explicit opt-out list in the contract test.
 */
import type { StudyMode } from '@/types/study-modes';

export interface MarketedStudyMode {
  /** Display label used in /features cards and SEO copy. */
  label: string;
  /** Underlying DB ids this marketed mode covers. */
  dbModes: readonly StudyMode[];
}

export const MARKETED_STUDY_MODES: readonly MarketedStudyMode[] = [
  { label: 'Flashcards (Target → English)', dbModes: ['flashcard-normal'] },
  { label: 'Flashcards (English → Target)', dbModes: ['flashcard-reversed'] },
  { label: 'Image Mode',                    dbModes: ['image-association'] },
  { label: 'Sentence Practice',             dbModes: ['sentence-practice-easy', 'sentence-practice-hard'] },
  { label: 'Dictation',                     dbModes: ['dictation'] },
  { label: 'Read Aloud',                    dbModes: ['read-aloud'] },
  { label: 'Shadowing',                     dbModes: ['shadowing'] },
] as const;

/** Public marketing count. Use this everywhere instead of hard-coding "6" or "7". */
export const MARKETED_STUDY_MODE_COUNT = MARKETED_STUDY_MODES.length;
